export default class ProductHomePageSectionModel {
  ProductHomePageSectionId: number | null;
  SectionName: string;
  DisplayOrder: number;
  IsActive: boolean;

  constructor() {
    this.ProductHomePageSectionId = null;
    this.SectionName = '';
    this.DisplayOrder = 0;
    this.IsActive = true;
  }
}
